<template>
	<ui-form :model="params.data" :transfer-model.sync="submitData" v-slot="{data}">
		<ui-hidden v-model="data.id" autosubmit/>
		<ui-text v-model="data.name" label="年级名称"/>
		<ui-image v-model="data.img" uploadPath="/admin/common/file/upload" label="封面"/>
		<ui-text v-model="data.sort" label="排序"/>
		<ui-select v-model="data.status" label="状态">
			<ui-option value="1" text="启用" tag-type="success"/>
			<ui-option value="0" text="禁用" tag-type="info"/>
		</ui-select>
		<ui-template>
			<ui-button type="submit" @submit="submit"></ui-button>
			<ui-button type="reset" v-if="params.type=='add'"></ui-button>
		</ui-template>
	</ui-form>
</template>

<script>
export default {
	props:['params','close'],
	data(){
		return {
			submitData:{}
		};
	},
	methods:{
		submit(){
			this.$axios.request({url:'/admin/grade/option',data:this.submitData,method:this.params.type})
			.then(data=>{
				this.close();
			}).end();
		},
	},
}
</script>

<style>
</style>
